import React, { Component } from 'react'

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';
import Pagination from 'react-js-pagination';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import IconButton from 'material-ui/IconButton';
import Box from '../ui/Box';

import NewScene from './NewScene';

//providers
import DataService from '../../services/DataService'; var ds = DataService;
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import Helper from '../../services/Helper'; var help = Helper;

export default class AllScenes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      all_scenes: [],
      current_offset: 0,
      activePage: 1,
      totalCount: 0,
      maxItems: 20,
      room_id: this.props.room_main_id,
      all_switches: {},
      is_edit: false,
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  maxItems = 7;
  componentDidMount() {
    this.getAllScenes(this.state.current_offset);
    this.getAllSwitches();
    window.addEventListener('updateScenesTable', (e) => {
      if (e.detail && e.detail == true) {
        this.refreshTable();
      }
    });
  }

  onChangePage(e) {
    this.getAllScenes(this.maxItems * (e - 1));
    this.setState({
      activePage: e
    })
  }

  getAllSwitches() {
    ds.getSwitchesInRoom(this.state.room_id, data => {
      let x = {};
      if (data.switchAppliances) {
        for (let i of data.switchAppliances) {
          x[i._id] = i;
        }
      }
      this.setState({
        all_switches: x
      })
    }, err => {});
  }

  getAllScenes(offset, offset_change = 0) {
    ds.getScenes(this.state.room_id,
      data => {
        this.setState({
          all_scenes: data
        });
        if (!offset_change) {
          let x = this.state.current_offset;
          this.setState({
            current_offset: offset + this.maxItems
          })
        }
      }, err => {}
    )
  }

  refreshTable(e) {
    this.getAllScenes(this.state.current_offset - this.maxItems > 0 ? this.state.current_offset - this.maxItems : 0, 1);
  }

  closeDialog(refresh = 0) {
    this.setState({
      dialog: {
        body: '',
        open: false,
        actions: []
      }
    })
    if (refresh) {
      this.getAllScenes(0);
    }
  }

  editScene(row, e) {
    this.setState({
      is_edit: <NewScene details={row} unMountMe={() => {
        this.setState({
          is_edit: null
        })
      }} room_main_id={this.state.room_id} />,
    })
  }

  deleteScene(row, e) {
    this.setState({
      dialog: {
        open: true,
        head: 'Delete',
        body: 'Delete Scene permanently?',
        actions: [
          <FlatButton
            label="Delete"
            primary
            onClick={() => {
              ds.postDeleteScene({ _id: row._id },
                data => {
                  let x = this.state.current_offset - this.state.maxItems;
                  this.closeDialog();
                  this.getAllScenes(x > 0 ? x : 0, 1);

                }, err => {}
              );
            }}
          />,
          <FlatButton
            label="Cancel"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    });
  }

  render() {
    let pagination;
    pagination = <Pagination
      activePage={this.state.activePage}
      itemsCountPerPage={this.maxItems}
      totalItemsCount={this.state.totalCount}
      pageRangeDisplayed={5}
      onChange={this.onChangePage.bind(this)} 
    />
    return (
      <div>
        <Box header='Scenes List'>
          <Dialog
            title={this.state.dialog.head}
            actions={this.state.dialog.actions}
            modal={false}
            open={this.state.dialog.open}
            onRequestClose={this.closeDialog.bind(this)}
          >
            {this.state.dialog.body || 'NA'}
          </Dialog>

          {
            this.state.is_edit ? this.state.is_edit 
            :
            <Table
              height={'30vh'}
              fixedHeader={true}
              fixedFooter={true}
              selectable={false}
              multiSelectable={false}
              bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
            >

            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn tooltip="Name">Name</TableHeaderColumn>
                <TableHeaderColumn tooltip="Actions">Actions</TableHeaderColumn>
                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody
              displayRowCheckbox={false}
              showRowHover={true}
              stripedRows={false}
            >
              {
                this.state.all_scenes.map((row, index) => (
                  <TableRow key={index}>
                    <TableRowColumn>{row.sceneName}</TableRowColumn>
                    <TableRowColumn>
                      {
                        row.actions && row.actions.length ? 
                          row.actions.map((act, ind) => {
                            return <div>{this.state.all_switches[act.switch_appliance_id] && act.act_type == "switch" ? this.state.all_switches[act.switch_appliance_id].name : ""}  {act.act_type == "switch" ? act.switch_state ? ' - Turn ON' : ' - Turn OFF' : ""} {act.act_type == "regulate" ? ` Set FAN Speed to ${act.dimm_value}` : ""}</div>
                          }) 
                        : null
                      }
                    </TableRowColumn>

                    <TableRowColumn>
                      <i className="material-icons link-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.editScene.bind(this, row)}
                      >
                        mode_edit
                      </i>

                      <i className="space"></i>

                      <i className="material-icons warn-fg"
                        style={{cursor:'pointer'}}
                        onClick={this.deleteScene.bind(this, row)}
                      >
                        delete
                      </i>
                    </TableRowColumn>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        }
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/scenes/AllScenes.js